<script lang="ts">
  import SectionCheckDeliveryList from '@/generated/sections/SectionCheckDeliveryList.vue';
  import Delivery from '@/extend/classes/Delivery';
  import { DeliveryTypes } from '@/generated/classes/Delivery';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import { defineComponent } from "vue";

  export default defineComponent({
    components: {},
    extends: SectionCheckDeliveryList,
    computed: {
      canAdd (): boolean {
        return false;
      },
      canEdit (): boolean {
        return false;
      }
    },
    methods: {
      defaultFilter (): void {
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = DeliveryTypes.CHEQUE;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
      },
      mdiAction (delivery: Delivery): string {
        return 'fas fa-landmark';
      },
      hasAction (delivery: Delivery): boolean {
        return delivery.bankId == 0;
      },
      execAction (delivery: Delivery): void {
        this.actionProgress = true;
        Delivery.simuBank(delivery).then((res) => {
          delivery.bankId = res.bankId
          this.actionProgress = false;
        }).catch(() => {
          this.actionProgress = false;
        });
      }
    }
  })

</script>
